import { Link } from 'react-router'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { colors } from '@mobi/component-library/Foundations'
import { KAMBI_CONTAINER_BG_COLOR } from '@core/Areas/KambiClient/constants'
import { fontFamiliesBold } from '@core/Settings/fonts'

export const TransactionTabsStyled = styled.div({
  height: '4.8rem',
  display: 'flex',
  background: colors.lavender[750],
})

export const TransactionTabStyled = styled(Link)({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 0.1rem',
  fontSize: '1.4rem',
  textDecoration: 'none',
  color: colors.white,
  background: hexColors.vividViolet,

  '&:first-of-type, &:last-of-type': {
    margin: 0,
  },
})

export const TransactionTabActiveStyled = styled(TransactionTabStyled)({
  pointerEvents: 'none',
  color: colors.black,
  background: KAMBI_CONTAINER_BG_COLOR,
})

export const RacingTransactionTitleStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  height: '4.8rem',
  padding: '0.8rem 0',
  background: KAMBI_CONTAINER_BG_COLOR,

  '& > h1': {
    margin: 0,
    paddingLeft: '1.5rem',
    fontFamily: fontFamiliesBold.brand,
    fontSize: '2rem',
    color: colors.lavender[750],
  },
})
